import { alpha, styled, Typography } from '@mui/material'
import { iconSizes } from '@ui/iconSizes'

export const Root = styled('div', {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'compact' && propName !== 'fullHeight',
})<{ compact?: boolean; fullHeight?: boolean }>(({ theme, compact, fullHeight }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.25),
  padding: compact ? theme.spacing(2.5) : theme.spacing(4.5, 2.5),
  textAlign: 'center',
  // Callers that reserve a box (chart cards reserve their height to stop the
  // page jumping) need the message centred in it, not stranded at the top.
  ...(fullHeight
    ? {
        height: '100%',
        justifyContent: 'center',
      }
    : {}),
}))

export const IconChip = styled('div')(({ theme }) => ({
  '& .MuiSvgIcon-root': {
    color: theme.palette.text.disabled,
    fontSize: iconSizes.lg,
  },
  alignItems: 'center',
  backgroundColor: alpha(theme.palette.text.primary, 0.06),
  borderRadius: '50%',
  display: 'flex',
  flexShrink: 0,
  height: theme.spacing(6.75),
  justifyContent: 'center',
  width: theme.spacing(6.75),
}))

export const Title = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  fontWeight: 600,
}))

export const Hint = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  lineHeight: 1.5,
  marginTop: theme.spacing(-0.5),
  maxWidth: '37rem',
}))
